<template>
  <div>
    <div class="ep-form-toolbar" v-if="task!==null">
        <div class="col-md-2 col-xs-2" style="padding-left: 25px;">
          <a class="btn btn-primary btn-labeled pull-left" @click="back()"><i class="fa fa-angle-double-left"></i> INDIETRO</a>
        </div>
        <div class="col-md-6 col-xs-6">

        </div>
        <div class="col-md-4 col-xs-4">
          <div class="paginator" v-if="footer_status_ && footer_status_.paginator">
            
            <a v-bind:class="[footer_status_.paginator.has_previous?'':'previous-disabled']" @click.prevent="pagePrevious()" :disabled="!footer_status_.paginator.has_previous"><i class="fa fa-chevron-left"></i></a>
            <select  class="form-control" style="max-width:60px"  v-model="footer_status_.page_selected">
              <option v-for="page_number in footer_status_.paginator.pages" :value="page_number" :key="page_number">{{page_number}}</option>
            </select> 
             <a v-bind:class="[footer_status_.paginator.has_next?'':'next-disabled']" @click.prevent="pageNext()" :disabled="!footer_status_.paginator.has_next"><i class="fa fa-chevron-right"></i></a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { dash_tasks, status_values } from "../../utils/env";

export default {
  name: "DashPanelFooter",
  props: {
    task: { type: Object },
    step: { type: Object },
    /* "paginator": {
        "current_page": 1,
        "end_index": 2,
        "has_next": false,
        "has_other_pages": false,
        "has_previous": false,
        "next_page_number": null,
        "pages": [
            1
        ],
        "previous_page_number": null,
        "start_index": 1
    } */
    footer_status: {type: Object, value: {'paginator': null, 'page_selected':1}},
  },
  data: function() {
    return {
      status_values: status_values,
      dash_tasks: dash_tasks,
      task_: this.task,
      footer_status_: this.footer_status
    };
  },
  methods: {
    back: function() {
      console.log("BACK");
      if ("workflow" in this.task) {
        if (this.task.workflow_current_index === 0) {
          this.task_ = this.dash_tasks[status_values.TASK_SELECT];
        } else {
          this.task_ = this.task;
          this.task_.workflow_current_index -= 1;
        }
      } else {
        this.task_ = this.dash_tasks[status_values.TASK_SELECT];
      }
      this.$emit("dash-event", { topic: "task-selected", task: this.task_ });
    },
    pagePrevious() {
      if(this.footer_status_.paginator.has_previous) this.footer_status_.page_selected -= 1;
      // this.footer_status.page_selected  = this.footer_status_.page_selected;
    },
    pageNext() {
      if(this.footer_status_.paginator.has_next) this.footer_status_.page_selected +=1;
      // this.footer_status.page_selected  = this.footer_status_.page_selected;
    }
  },
  watch: {
    'footer_status_':  {
      handler() {
      this.$root.footer_status = this.footer_status_;
      console.log('HANDLER (footer_status_)',this.footer_status_);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.paginator {
  margin-right: 8px;
  text-align: right;
}

  .paginator * {
    display: inline-block;
    margin: 2px;
  }

  .paginator a.previous-disabled  {
    opacity: 0.1;
  }

  .paginator a.next-disabled  {
    opacity: 0.1;
  }
</style>